export enum ProjectsDialogMode {
  Create = 'create',
  Edit = 'edit'
}
